<template>
  <div>
    <div id="filter-panel" class="filter-panel">
      <form
        ref="form"
        v-formulario-cache
        name="agendamentosFiltroForm"
        novalidate
        @submit.prevent
      >
        <div class="row">
          <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
            <SelecionarUnidade
              id="unidade"
              :mostrar-todos="false"
              :valor="filtro.unidade"
              :validacao="v$.filtro.unidade"
              @atualizar="atualizarUnidade"
              @pronto="unidadesProntas"
            />
          </div>
          <div class="col-xs-6 col-sm-4 col-md-4 col-lg-4">
            <SelecionarEspecialidade
              id="especialidade"
              :mostrar-todos="false"
              :valor="filtro.especialidade"
              :validacao="v$.filtro.especialidde"
              @atualizar="atualizarEspecialidade"
              @pronto="especialidadesProntas"
            />
          </div>
          <div class="col-xs-6 col-sm-2 col-md-2 col-lg-2">
            <SelecionarData
              id="dia"
              :valor="filtro.dia"
              :validacao="v$.filtro.dia"
              @atualizar="atualizarDia"
            />
          </div>
        </div>
      </form>
    </div>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <ul class="agendamento-legenda">
          <li
            v-for="status in statusAgendamento"
            :key="status.id"
            :class="'agendamento-legenda-item--' + status.id"
            class="agendamento-legenda-item"
          >
            {{ status.descricao }}
          </li>
        </ul>
      </div>
    </div>
    <Tabs>
      <Tab title="Horários">
        <HorariosAgendamento
          :agenda-completa="agendaCompleta"
          :agendas="agendas"
          :data="filtro.dia"
          :especialidade="filtro.especialidade"
          :unidade="filtro.unidade"
          @atualizar="atualizarHorariosAgendamento"
          @atualizarAgendamento="atualizarAgendamento"
        />
        <Teleport to="body">
          <div v-if="scrollTopVisisble" class="ir-para-o-topo-btn-wrapper">
            <button
              data-test-id="button-scrolltop-1"
              class="ir-para-o-topo-btn"
              @click="scrollTop"
            >
              Ir para o topo
            </button>
          </div>
        </Teleport>
      </Tab>
      <Tab v-if="verificaAcao('encaixar_horario')" title="Encaixe">
        <EncaixeAgendamento
          :agendas="agendas"
          :data="filtro.dia"
          :especialidade="filtro.especialidade"
          :unidade="filtro.unidade"
          @atualizar="atualizarEncaixeAgendamento"
          @atualizarAgendamento="atualizarAgendamento"
        />
      </Tab>
      <Tab title="Profissionais">
        <HorariosProfissional
          :data="filtro.dia"
          :especialidade="filtro.especialidade"
          :unidade="filtro.unidade"
          :horarios-profissional="horariosProfissional"
        />
      </Tab>
    </Tabs>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import debounce from 'lodash/debounce'
import moment from 'moment'
import { Tab, Tabs } from 'uiv'

import SelecionarData from '@/componentes/formulario/SelecionarData'
import SelecionarEspecialidade from '@/componentes/formulario/SelecionarEspecialidade'
import SelecionarUnidade from '@/componentes/formulario/SelecionarUnidade'
import { useMenu } from '@/composables/useMenu'
import STATUS_AGENDAMENTO from '@/constantes/dominio/STATUS_AGENDAMENTO'
import AgendamentoServico from '@/servicos/AgendamentoServico'
import AgendaServico from '@/servicos/AgendaServico'
import ControleAcessoServico from '@/servicos/ControleAcessoServico'
import ProfissionalServico from '@/servicos/ProfissionalServico'

import EncaixeAgendamento from './EncaixeAgendamento'
import HorariosAgendamento from './HorariosAgendamento'
import HorariosProfissional from './HorariosProfissional'

const agendaServico = new AgendaServico()
const agendamentoServico = new AgendamentoServico()
const controleAcessoServico = new ControleAcessoServico()
const profissionalServico = new ProfissionalServico()

export default {
  components: {
    EncaixeAgendamento,
    HorariosAgendamento,
    HorariosProfissional,
    SelecionarData,
    SelecionarUnidade,
    SelecionarEspecialidade,
    Tabs,
    Tab,
  },

  setup() {
    useMenu(11)
    return { v$: useVuelidate() }
  },
  data() {
    return {
      intervalId: null,
      scrollTopVisisble: false,
      agendas: [],
      agendaCompleta: [],
      horariosProfissional: [],
      filtro: {
        unidade: '',
        especialidade: '',
        dia: '',
      },
      savedForm: null,
      unidadePronta: false,
      especialidadePronta: false,
      pesquisarDebounced: () => {},
    }
  },
  computed: {
    statusAgendamento() {
      return STATUS_AGENDAMENTO.valores
    },
  },
  validations: {
    filtro: {
      unidade: { required },
      especialidade: { required },
      dia: { required },
    },
  },
  created() {
    this.carregarFiltroInicial()

    const recuperarAgendasEHorarios = () => {
      this.recuperarAgenda()
      this.recuperarHorarios()
    }

    this.pesquisarDebounced = debounce(recuperarAgendasEHorarios, 250, {
      maxWait: 1000,
    })
  },
  mounted() {
    window.addEventListener('scroll', this.scrollListener)
    this.aplicarFiltroSalvo()

    if (!this.savedForm) {
      this.pesquisar()
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scrollListener)
  },
  methods: {
    atualizarUnidade(unidade) {
      this.filtro.unidade = unidade
      this.persistirFiltroCache()
      this.pesquisar()
    },
    unidadesProntas() {
      this.unidadePronta = true

      if (this.savedForm && this.savedForm.unidade) {
        this.filtro.unidade = this.savedForm.unidade
      }

      this.aplicarFiltroSalvo()
    },
    especialidadesProntas() {
      this.especialidadePronta = true

      if (this.savedForm && this.savedForm.especialidade) {
        this.filtro.especialidade = this.savedForm.especialidade
      }

      this.aplicarFiltroSalvo()
    },
    aplicarFiltroSalvo() {
      if (!this.savedForm) {
        return
      }

      const esperaUnidade = !!this.savedForm.unidade
      const esperaEspecialidade = !!this.savedForm.especialidade
      const unidadeOk = !esperaUnidade || this.unidadePronta
      const especialidadeOk = !esperaEspecialidade || this.especialidadePronta

      if (unidadeOk && especialidadeOk) {
        this.persistirFiltroCache()
        this.savedForm = null
        this.pesquisar()
      }
    },
    normalizarDia(dia) {
      if (moment(dia, 'DD/MM/YYYY', true).isValid()) {
        return moment(dia, 'DD/MM/YYYY').format()
      }

      if (moment(dia).isValid()) {
        return moment(dia).format()
      }

      return moment().format()
    },
    carregarFiltroInicial() {
      const formsData = JSON.parse(
        window.localStorage.getItem('tu.formularioCache')
      )

      this.savedForm = formsData && formsData.agendamentosFiltroForm
      this.unidadePronta = false
      this.especialidadePronta = false

      if (this.savedForm) {
        this.filtro.unidade = this.savedForm.unidade || ''
        this.filtro.especialidade = this.savedForm.especialidade || ''
        this.filtro.dia = this.normalizarDia(this.savedForm.dia)
        return
      }

      this.filtro.unidade = 'TACTUS ÁGUAS CLARAS'
      this.filtro.especialidade = 'Pilates'
      this.filtro.dia = moment().format()
    },
    atualizarEspecialidade(especialidade) {
      this.filtro.especialidade = especialidade
      this.persistirFiltroCache()
      this.pesquisar()
    },
    atualizarDia(dia) {
      this.filtro.dia = dia
      this.persistirFiltroCache()
      this.pesquisar()
    },
    persistirFiltroCache() {
      const formsData =
        JSON.parse(window.localStorage.getItem('tu.formularioCache')) || {}
      const dia =
        this.filtro.dia && moment(this.filtro.dia).isValid()
          ? moment(this.filtro.dia).format('DD/MM/YYYY')
          : ''

      formsData.agendamentosFiltroForm = {
        ...(formsData.agendamentosFiltroForm || {}),
        unidade: this.filtro.unidade || '',
        especialidade: this.filtro.especialidade || '',
        dia,
      }

      window.localStorage.setItem(
        'tu.formularioCache',
        JSON.stringify(formsData)
      )
    },
    atualizarHorariosAgendamento() {
      this.pesquisar()
    },
    atualizarEncaixeAgendamento() {
      this.pesquisar()
    },
    verificaAcao(nome) {
      return controleAcessoServico.verificaAcao(nome)
    },
    atualizarAgendamento(agendamento) {
      let agenda = {}

      if (agendamento.encaixe) {
        agenda = this.agendas.find((agenda) => agenda.encaixe)
      } else {
        agenda = this.agendas.find((agenda) => agenda.hora === agendamento.hora)
      }

      const agendamentoEncontrado = agenda.agendamentos.find(
        (a) =>
          a.hora === agendamento.hora &&
          a.paciente._id === agendamento.paciente._id
      )
      agendamentoEncontrado._id = agendamento._id
      agendamentoEncontrado.paciente = agendamento.paciente
      agendamentoEncontrado.profissional = agendamento.profissional
      agendamentoEncontrado.style = agendamento.style
      agendamentoEncontrado.encaixe = agendamento.encaixe
      agendamentoEncontrado.repetir = agendamento.repetir
      agendamentoEncontrado.status = agendamento.status
      agendamentoEncontrado.statusAgendamentoSeguintes =
        agendamento.statusAgendamentoSeguintes
      agendamentoEncontrado.statusAtual = agendamento.statusAtual
    },
    pesquisar() {
      if (this.filtro.unidade && this.filtro.especialidade && this.filtro.dia) {
        this.v$.$touch()

        if (!this.v$.filtro.$invalid) {
          this.pesquisarDebounced()
        }
      }
    },
    recuperarAgenda() {
      this.agendas = []
      this.encaixes = []

      agendamentoServico
        .recuperarAgendamentos({
          ...this.filtro,
          dia: moment(this.filtro.dia).format('YYYY-MM-DD'),
        })
        .then((result) => {
          if (result && result.agenda && result.agenda.length) {
            const horas = result.agenda[0].horarios.horas

            if (horas) {
              horas.forEach((hora) => {
                if (!hora.agendamentos) {
                  hora.agendamentos = []
                }

                hora.agendamentos.forEach((agendamento) => {
                  agendamento.paciente.valido = true
                  const status = this.statusAgendamento.find(
                    (x) => x.id === agendamento.status
                  )

                  if (status) {
                    agendamento.style = status.id
                    agendamento.statusAtual = status.descricao
                    agendamento.statusAgendamentoSeguintes = []

                    status.proximo.forEach((key, value) => {
                      const s = this.statusAgendamento.find((x) => x.id === key)

                      if (this.verificaAcao(s.acao)) {
                        agendamento.statusAgendamentoSeguintes.push(s)
                      }
                    })
                  }

                  agendamento.repetir = {
                    acabarEm: '',
                    regra: '',
                    repeticoes: [],
                  }

                  agendamento.original = ''
                  agendamento.derivados = []
                  agendamento.sequencial = ''
                })
              })

              horas.forEach((hora) => {
                const qtdEncaixes = hora.agendamentos.filter(
                  (a) => a.encaixe
                ).length
                const restante =
                  hora.quantidade - hora.agendamentos.length + qtdEncaixes

                for (let i = 0; i < restante; i++) {
                  const statusInicial = this.statusAgendamento.find(
                    (x) => x.id === 'marcado'
                  )
                  const agendamentoNovo = {
                    paciente: {
                      nome: '',
                      telefone: '',
                      preAgendamento: false,
                      valido: false,
                      convenio: {
                        nome: '',
                        plano: '',
                      },
                    },
                    profissional: '',
                    style: '',
                    status: '',
                    encaixe: false,
                    statusAgendamentoSeguintes: [],
                    repetir: {
                      acabarEm: '',
                      regra: '',
                      repeticoes: [],
                    },
                    original: '',
                    sequencial: '',
                    derivados: [],
                    guia: [],
                  }

                  if (this.verificaAcao(statusInicial.acao)) {
                    agendamentoNovo.status = 'marcado'
                    agendamentoNovo.statusAgendamentoSeguintes.push(
                      statusInicial
                    )
                  }

                  hora.agendamentos.push(agendamentoNovo)
                }
              })
            }

            this.agendas = result.agenda[0].horarios.horas
          }
        })

      agendaServico
        .recuperarAgendas({
          unidade: this.filtro.unidade,
          especialidade: this.filtro.especialidade,
        })
        .then((result) => {
          this.agendaCompleta = result.agenda
        })
    },
    recuperarHorarios() {
      profissionalServico
        .recuperarHorariosAgendamento({
          dia: moment(this.filtro.dia).format('YYYY-MM-DD'),
          unidade: this.filtro.unidade,
          especialidade: this.filtro.especialidade,
        })
        .then((res) => {
          this.horariosProfissional = res.horarios
        })
    },
    scrollListener() {
      this.scrollTopVisisble = window.scrollY > 150
    },
    scrollTop() {
      this.intervalId = setInterval(() => {
        if (window.pageYOffset === 0) {
          clearInterval(this.intervalId)
        }
        window.scroll(0, window.pageYOffset - 50)
      }, 20)
    },
  },
}
</script>

<style scoped>
.filter-panel {
  padding: 8px 15px 12px 15px;
  margin: 0;
  margin-bottom: 2rem;
  background-color: #f9f9f9;
  border: 1px solid #ecf0f1;
  border-radius: 2px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}

.ir-para-o-topo-btn-wrapper {
  position: fixed;
  right: 20px;
  bottom: 60px;
  z-index: 99;
  display: flex;
}

@media (min-width: 1200px) {
  .ir-para-o-topo-btn-wrapper {
    right: 140px;
  }
}

.ir-para-o-topo-btn {
  padding: 15px;
  margin-left: auto;
  font-size: 18px;
  color: white;
  cursor: pointer;
  background-color: #008080;
  border: none;
  border-radius: 8px;
  outline: none;
}
</style>
